<template>
  <div id="plvPPt" class="document" ref="doc" :class="{ full: isFullscreen }">
    <!--    <img-->
    <!--      class="ppt-default"-->
    <!--      :src="defaultUrl"-->
    <!--      alt=""-->
    <!--      v-if="!pptIsOpen || !isHavePpt"-->
    <!--    />-->
    <img
      class="ppt-default"
      v-if="
        !pptIsOpen ||
          !isHavePpt ||
          (pptUrl == '' && pptIsOpen && playerType !== 'polyv')
      "
      :src="defaultUrl"
    />
    <div class="ppt-container" v-if="isHavePpt && playerType !== 'polyv'">
      <img
        class="ppt-source"
        ref="pptPic"
        v-if="pptUrl !== '' && pptIsOpen"
        :src="pptUrl"
        alt=""
      />
      <div
        class="ppt-full"
        v-show="pptIsOpen && pptUrl"
        @click="onFullscreen"
      ></div>
      <div
        class="ppt-prev"
        v-if="pptIsAllowTurnPage && isHavePpt"
        v-show="pptCurrentPageIndex > 1"
        @click="onPrev"
      ></div>
      <div
        class="ppt-next"
        v-if="pptIsAllowTurnPage && isHavePpt"
        v-show="pptCurrentPageIndex < pptTotalPage"
        @click="onNext"
      ></div>
    </div>
    <div
      class="ppt-page"
      v-if="pptIsAllowTurnPage && !isPlayBackStatus && isHavePpt"
      v-show="pptCurrentPageIndex != 0 && pptTotalPage != 0"
    >
      {{ pptCurrentPageIndex }} / {{ pptTotalPage }}
    </div>
    <div class="button-download" v-if="false">
      <span>资料下载</span>
    </div>
    <!--    polyv 控件-->
    <div class="polyv-control" v-if="isHavePpt && playerType == 'polyv'">
      <div
        class="polyv-control-prev"
        v-if="pptIsAllowTurnPage && isHavePpt"
        v-show="pptCurrentPageIndex > 1"
        @click="onPrev"
      ></div>
      <div
        class="polyv-control-next"
        v-if="pptIsAllowTurnPage && isHavePpt"
        v-show="
          pptCurrentPageIndex < pptTotalPage &&
            (pptCurrentPageIndex < polyvMaxPptPage ? true : false)
        "
        @click="onNext"
      ></div>
      <div
        class="polyv-control-page"
        v-if="pptIsAllowTurnPage && isHavePpt"
        v-show="pptCurrentPageIndex != 0 && pptTotalPage != 0"
      >
        {{ pptCurrentPageIndex }} / {{ pptTotalPage }}
      </div>
    </div>
  </div>
</template>

<script>
import "@/common/viewer/viewer.css";
import Viewer from "@/common/viewer/viewer";
import { $subscriber, interact } from "fire-wind-water";
import $ from "jquery";

export default {
  name: "Document",
  data() {
    return {
      defaultUrl: require("../../assets/images/ppt/ppt-default-wap.jpg"),
      pptUrl: "", // 当前ppt地址
      pptCurrentPageIndex: 0, // 当前ppt页码
      pptTotalPage: 0, // ppt总页数
      pptIsOpen: false, // ppt是否显示
      pptIsAllowTurnPage: false, // ppt是否允许用户自主切换
      viewer: null,
      isFullscreen: false,
      isPlayBackStatus: true,
      isHavePpt: false,
      playerType: "",
      polyvMaxPptPage: 0 //适配保利未 新加字段 ppt跟随模式最大可切换页码数
    };
  },
  computed: {
    fulled() {
      return (this.viewer && this.viewer.fulled) || false;
    }
  },
  mounted() {
    let _this = this;
    window.$sk.webinar.module({
      //播放器状态
      skPlayerStatus(res) {
        let data = res[0];
        if (data.content.data == "直播回放") {
          _this.isPlayBackStatus =
            data.content.data == "直播回放" ? true : false;
        } else {
          $subscriber.emit("onVideoStatus", data); //发布播放器是回放状态
        }
      },
      //ppt发生改变
      skPptInfoChange(res) {
        let pptInfo = res[0];
        let {
          pptCurrentPageIndex,
          pptTotalPage,
          pptUrl,
          pptIsOpen,
          pptIsAllowTurnPage,
          isHavePpt
        } = pptInfo;
        _this.pptCurrentPageIndex = pptCurrentPageIndex;
        _this.pptTotalPage = pptTotalPage;
        _this.pptUrl = pptUrl;
        _this.pptIsOpen = pptIsOpen;
        _this.pptIsAllowTurnPage = pptIsAllowTurnPage;
        _this.isHavePpt = isHavePpt;
        let classView = document.querySelector(".ppt-container");
        if (!isHavePpt) {
          _this.pptUrl = "";
          setTimeout(() => {
            if (classView) {
              document.querySelector(".ppt-container").style.zIndex = "-1";
            }
          }, 500);
        } else {
          if (_this.playerType !== "polyv") {
            if (classView) {
              document.querySelector(".ppt-container").style.zIndex = "0";
            }
          }
        }
        //如果是 保利威播放器  清楚原有样式
        if (_this.playerType == "polyv") {
          //左右切换样式
          let pcPptNav = $("#pptH5SettingNav");
          if (pcPptNav) {
            pcPptNav.remove();
          }
          window.$sk.webinar.skSdkEvent({ type: "polyvResizePpt", data: {} });
          //若 传来的当前页码数大于存的页码数复制，否则 不赋值
          _this.polyvMaxPptPage =
            pptCurrentPageIndex > _this.polyvMaxPptPage
              ? pptCurrentPageIndex
              : _this.polyvMaxPptPage;
        }
        if (_this.pptUrl && _this.isHavePpt) {
          // 初始化ppt插件
          _this.$nextTick(() => {
            setTimeout(() => {
              window.$sk.webinar.skPptEvent({
                type: "initPPt",
                data: {
                  id: _this.$refs.pptPic
                }
              });
            }, 100);
          });
        }
      }
    });
    $subscriber.subscribe("webinarInfo", data => {
      _this.playerType = data.webCastProvider;
    });
    $subscriber.subscribe("changeScreenStatus", () => {
      this.resizePPt();
    });
    window.addEventListener("resize", () => {
      this.resizePPt();
    });
  },
  watch: {
    isFullscreen() {
      this.$nextTick(() => {
        this.$store.commit("setOffsetHide", this.isFullscreen);
        this.resizePPt();
      });
    }
  },
  methods: {
    resizePPt() {
      this.$nextTick(() => {
        // if (this.viewer) {
        //   this.viewer.resize();
        // }
        window.$sk.webinar.skPptEvent({
          type: "resizePPt",
          data: {}
        });
      });
      // let _this = this;
      // setTimeout(() => {
      //   if (_this.viewer) {
      //     _this.viewer.resize();
      //   }
      // }, 300);
    },
    removeResizePPt() {
      console.log("移除监听resize");
    },
    // 自定义控制项包括：上一页，下一页，全屏
    onPrev() {
      this.pptCurrentPageIndex -= 1;
      if (this.playerType == "mudu") {
        window.$sk.webinar.skPptEvent({
          type: "onPrev",
          data: {
            val: this.pptCurrentPageIndex
          }
        });
      } else {
        window.$sk.webinar.skSdkEvent({
          type: "onPrev"
        });
      }
    },
    onNext() {
      this.pptCurrentPageIndex += 1;
      if (this.playerType == "mudu") {
        window.$sk.webinar.skPptEvent({
          type: "onNext",
          data: {
            val: this.pptCurrentPageIndex
          }
        });
      } else {
        window.$sk.webinar.skSdkEvent({
          type: "onNext"
        });
      }
    },
    onFullscreen() {
      this.isFullscreen = !this.isFullscreen;
    }
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.removeResizePPt());
  }
};
</script>
